module.exports = __webpack_public_path__ + "static/media/home.d59a449d.png";